import {IpproMapLayer} from '@/app/shared/components/ippro-map/vl-ippro-map';
import {WMTSCapabilities} from 'ol/format';
import grb_capabilities_xml from './grb-capabilities.xml?raw';
import omwrgbmrvl_capabilities_xml from './omwrgbmrvl-capabilities.xml?raw';
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';
import proj4 from "proj4";
import {register} from 'ol/proj/proj4';

//////////////////////////////////////////
// TODO: 1 plaats, maar dit moet wel gebeuren VOORDAT de sources kunnen aangemaakt worden
proj4.defs(
    "EPSG:31370",
    "+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.868628,52.297783,-103.723893,0.336570,-0.456955,1.842183,-1.2747 +units=m +no_defs"
);
proj4.defs(
    "EPSG:3812",
    "+proj=lcc +lat_0=50.797815 +lon_0=4.35921583333333 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs"
);
// register in openlayers
register(proj4);
//
//////////////////////////////////////////

class LayerService {

    private _grbLayerTile72;
    private _grbLayerTile2008;
    private _orthoLayerTile72;
    private _orthoLayerTile2008;

    private _grbLayer72: IpproMapLayer;
    private _grbLayer2008: IpproMapLayer;
    private _orthoLayer72: IpproMapLayer;
    private _orthoLayer2008: IpproMapLayer;

    private _createGrbLayer(tileTemplate): IpproMapLayer {
        return {
            name: "GRB",
            id: "grb_bsk",
            thumbnail: {
                src: "/img/grb.png",
                alt: "Afbeelding van Basiskaart"
            },
            tileTemplate: tileTemplate,
            tile: null
        };
    }

    private _createOrthoLayer(tileTemplate): IpproMapLayer {
        return {
            name: "Luchtfoto",
            id: "omwrgbmrvl",
            thumbnail: {
                src: "/img/ortho.png",
                alt: "Afbeelding van Orthofoto"
            },
            tileTemplate: tileTemplate,
            tile: null
        };
    }

    public initLayers() {
        const capabilitiesParser = new WMTSCapabilities();
        const grb_capabilities = capabilitiesParser.read(grb_capabilities_xml);
        const omwrgbmrvl_capabilities = capabilitiesParser.read(omwrgbmrvl_capabilities_xml);

        // export const projectionExtent72: Extent = [22000, 153000, 259000, 245000];
        // export const projectionExtent2008: Extent = [500000.0, 537856.0, 762144.0, 800000.0];

        this._grbLayerTile72 = {
            //extent: projectionExtent72,
            source: new WMTS(optionsFromCapabilities(grb_capabilities, {
                layer: 'grb_bsk',
                matrixSet: 'BPL72VL',
            }))
        };
        //this._grbLayerTile72.source.setRenderReprojectionEdges(true);
        this._grbLayer72 = this._createGrbLayer(this._grbLayerTile72);

        this._grbLayerTile2008 = {
            //extent: projectionExtent2008,
            source: new WMTS(optionsFromCapabilities(grb_capabilities, {
                layer: 'grb_bsk',
                matrixSet: 'BPL2008VL',
            }))
        };
        //this._grbLayerTile2008.source.setRenderReprojectionEdges(true);
        this._grbLayer2008 = this._createGrbLayer(this._grbLayerTile2008);


        this._orthoLayerTile72 = {
            //extent: projectionExtent72,
            source: new WMTS(optionsFromCapabilities(omwrgbmrvl_capabilities, {
                layer: 'omwrgbmrvl',
                matrixSet: 'BPL72VL',
            }))
        };
        //this._orthoLayerTile72.source.setRenderReprojectionEdges(true);
        this._orthoLayer72 = this._createOrthoLayer(this._orthoLayerTile72);


        this._orthoLayerTile2008 = {
            //extent: projectionExtent2008,
            source: new WMTS(optionsFromCapabilities(omwrgbmrvl_capabilities, {
                layer: 'omwrgbmrvl',
                matrixSet: 'BPL2008VL',
            }))
        };
        //this._orthoLayerTile2008.source.setRenderReprojectionEdges(true);
        this._orthoLayer2008 = this._createOrthoLayer(this._orthoLayerTile2008);
    }

    public getRegisteredLayersForProjection(projectionCode: string): IpproMapLayer[] {
        if (projectionCode === 'EPSG:31370') {
            return [this._grbLayer72, this._orthoLayer72];
        }
        if (projectionCode === 'EPSG:3812') {
            return [this._grbLayer2008, this._orthoLayer2008];
        }
        throw new Error(`Unsupported projection: ${projectionCode}`);
    }
}

let layerService: LayerService = null;

export function getRegisteredLayersForProjection(projectionCode: string): IpproMapLayer[] {
    if (!layerService) {
        layerService = new LayerService();
        layerService.initLayers();
    }
    return layerService.getRegisteredLayersForProjection(projectionCode);
}

export function getResolutions(): number[] {
    // TODO: from capabilities?
    return [
        1024,
        512,
        256,
        128,
        64,
        32,
        16,
        8,
        4,
        2,
        1,
        0.5,
        0.25,
        0.125,
        0.0625,
        0.03125
    ];
}
